import { type FlowSchedulingBlockConfig, FlowSchedulingBlockConfigSchema } from 'flow-schema';

import { SchedulingFormFields } from './FormFields';
import { schedulingDocumentationMarkdown } from './documentation';
import { type BlockConfigProps } from '../../types';

export const schedulingConfig: BlockConfigProps<FlowSchedulingBlockConfig> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'scheduling',
  defaultConfig: {
    practiceIds: [],
    providerUserIds: [],
    appointmentTypes: [],
  },
  configFields: {
    schema: FlowSchedulingBlockConfigSchema,
    FormFields: SchedulingFormFields,
  },
  documentationMarkdown: schedulingDocumentationMarkdown,
};
